export default __webpack_public_path__ + "static/media/enfantperdu.1a89865c.jpg";